import { API_BASE_URL } from "@constants/env";
import axios from "axios";

const defaultOptions = {
    baseURL: API_BASE_URL,
};

// Create instance
export const apiInstance = axios.create(defaultOptions);
